import axios from "axios";

export const ApiAxios = axios.create({
    baseURL: process.env.REACT_APP_AKCIO_ENDPOINT,
    headers: {
        'Content-Type': 'application/json',
        'Token': process.env.REACT_APP_AKCIO_TOKEN
    }
});
